/*
  boleta-factura v1.1
  Captura datos boleta/factura (SII Chile) → cart.attributes via Shopify Ajax API.
  Compatible con themes que inyectan el cart drawer vía innerHTML (script debe
  cargarse desde layout/theme.liquid, no desde el snippet).

  Robustez:
  - Sequence ID en pushes → respuestas out-of-order no pisan estado del user
  - loadStateFromCart skip si input focused o push pendiente
  - MutationObserver debounced (100ms)
  - flushKeepalive valida antes (no envía datos rotos al cerrar tab)
  - Buffer sessionStorage TTL 30 min
  - Error visible al user si push falla 3 retries (no silent fail)
  - Guard document.readyState (script puede cargar después de DOMContentLoaded)
*/
if (!window.__BF_LOADED__) {
  window.__BF_LOADED__ = true;
  (function() {
    'use strict';

    var MAX_RETRIES = 3;
    var BASE_RETRY_DELAY = 300;
    var BUFFER_TTL_MS = 30 * 60 * 1000; // 30 min
    var SS_KEY = 'bf_buffer_v3';

    // Tracking de pushes para evitar race conditions: si user clickea rápido
    // Boleta→Factura→Boleta, hay 3 POSTs en vuelo. El último gana, pero si
    // llegan desordenados o un loadStateFromCart se mete entremedio, puede
    // pisar el estado del user con datos viejos.
    var pushSeq = 0;
    var lastAppliedSeq = 0;
    var inFlightPushes = 0;

    function getEl(id) { return document.getElementById(id); }

    function fmtRut(v) {
      var c = v.replace(/[^0-9kK]/g, '').toUpperCase();
      if (c.length < 2) return c;
      return c.slice(0, -1).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + '-' + c.slice(-1);
    }

    function chkRut(r) {
      r = r.replace(/\./g, '').replace('-', '');
      if (r.length < 7) return false;
      var b = r.slice(0, -1);
      var dv = r.slice(-1).toUpperCase();
      var s = 0, m = 2;
      for (var i = b.length - 1; i >= 0; i--) {
        s += parseInt(b[i], 10) * m;
        m = m === 7 ? 2 : m + 1;
      }
      var x = 11 - (s % 11);
      return dv === (x === 11 ? '0' : x === 10 ? 'K' : String(x));
    }

    function debounce(fn, ms) {
      var timer;
      return function() {
        clearTimeout(timer);
        timer = setTimeout(fn, ms || 300);
      };
    }

    function getDocType() {
      var checked = document.querySelector('input[name="attributes[billing_document_type]"]:checked');
      return checked ? checked.value : '39';
    }

    function isInvoice() {
      return getDocType() === '33';
    }

    function getInputs() {
      return {
        rut: getEl('bf-rut'),
        company: getEl('bf-company'),
        giro: getEl('bf-giro'),
        rutErr: getEl('bf-rut-error'),
        compErr: getEl('bf-company-error'),
        giroErr: getEl('bf-giro-error'),
        topErr: getEl('bf-form-error'),
        invoiceBox: getEl('bf-invoice-fields')
      };
    }

    // ¿Alguno de los inputs del módulo tiene foco? Si sí, NO pisar su value
    // desde loadStateFromCart (el user está tipeando).
    function inputsAreFocused() {
      var active = document.activeElement;
      if (!active || !active.id) return false;
      return ['bf-rut', 'bf-company', 'bf-giro'].indexOf(active.id) !== -1;
    }

    function showInvoiceFields() {
      var els = getInputs();
      if (!els.invoiceBox) return;
      var show = isInvoice();
      els.invoiceBox.style.display = show ? 'block' : 'none';
      [els.rut, els.company, els.giro].forEach(function(f) {
        if (f) f.required = show;
      });
    }

    function updateRadioVisuals() {
      var opts = document.querySelectorAll('.bf-radio-option');
      for (var i = 0; i < opts.length; i++) {
        var inp = opts[i].querySelector('input[type="radio"]');
        var shouldBeActive = inp && inp.checked;
        var isActive = opts[i].classList.contains('bf-option-active');
        if (shouldBeActive && !isActive) {
          opts[i].classList.add('is-checked', 'bf-option-active');
        } else if (!shouldBeActive && isActive) {
          opts[i].classList.remove('is-checked', 'bf-option-active');
        }
      }
    }

    function fireChange(el) {
      var evt;
      try { evt = new Event('change', { bubbles: true }); }
      catch (e) {
        evt = document.createEvent('Event');
        evt.initEvent('change', true, true);
      }
      el.dispatchEvent(evt);
    }

    function buildAttrs() {
      var els = getInputs();
      var isInv = isInvoice();
      return {
        billing_document_type: getDocType(),
        billing_rut: isInv && els.rut ? fmtRut(els.rut.value) : '',
        billing_company_name: isInv && els.company ? els.company.value.trim() : '',
        billing_business_type: isInv && els.giro ? els.giro.value.trim() : ''
      };
    }

    function toggleCheckoutBtns(ok) {
      var btns = document.querySelectorAll('[name="checkout"], a[href$="/checkout"]');
      btns.forEach(function(el) {
        // Eurus oculta con display:none tanto a [disabled] como a [aria-disabled="true"].
        // Forzar display: inline-flex cuando disabled para que se vea, no oculto.
        el.style.pointerEvents = ok ? 'auto' : 'none';
        el.style.opacity = ok ? '1' : '0.55';
        el.style.cursor = ok ? 'pointer' : 'not-allowed';
        el.removeAttribute('aria-disabled');
        if (ok) {
          el.style.removeProperty('display');
          el.removeAttribute('data-bf-disabled');
        } else {
          el.style.setProperty('display', 'inline-flex', 'important');
          el.setAttribute('data-bf-disabled', 'true');
        }
      });
    }

    function showTopError(msg) {
      var els = getInputs();
      if (els.topErr) {
        els.topErr.textContent = msg;
        els.topErr.style.display = 'block';
      }
    }

    function clearTopError() {
      var els = getInputs();
      if (els.topErr && els.topErr.dataset.bfNetErr === 'true') {
        els.topErr.style.display = 'none';
        els.topErr.removeAttribute('data-bf-net-err');
      }
    }

    function validateAll(final) {
      var ok = true;
      var els = getInputs();

      if (isInvoice()) {
        var okRut = els.rut ? chkRut(els.rut.value) : false;
        var okComp = els.company ? els.company.value.trim().length >= 3 : false;
        var okGiro = els.giro ? els.giro.value.trim().length >= 3 : false;
        ok = okRut && okComp && okGiro;

        function showErr(el, eEl, valid) {
          if (!el || !eEl) return;
          var show = !valid && (final || (el.value && el.dataset.hasBlurred === 'true'));
          eEl.style.display = show ? 'block' : 'none';
          el.classList.toggle('input-error', show);
        }
        showErr(els.rut, els.rutErr, okRut);
        showErr(els.company, els.compErr, okComp);
        showErr(els.giro, els.giroErr, okGiro);
      } else {
        [els.rutErr, els.compErr, els.giroErr].forEach(function(e) {
          if (e) e.style.display = 'none';
        });
        [els.rut, els.company, els.giro].forEach(function(e) {
          if (e) e.classList.remove('input-error');
        });
      }

      // El topErr puede tener 2 fuentes: validation (final && !ok && invoice) o
      // net error (data-bf-net-err). Si hay net error mostrado, dejarlo —
      // solo limpiar si el validation lo manejaría.
      if (els.topErr && els.topErr.dataset.bfNetErr !== 'true') {
        els.topErr.style.display = (final && !ok && isInvoice()) ? 'block' : 'none';
        if (final && !ok && isInvoice()) {
          els.topErr.textContent = 'Completa los datos para continuar al pago';
        }
      }

      toggleCheckoutBtns(ok);
      return ok;
    }

    // Push cart attributes — FormData con fetch keepalive + sequence tracking.
    // Acepta sin args (push nuevo) o con opts {count, seq} para retries internos.
    function pushCartAttributes(opts) {
      var isRetry = opts && typeof opts === 'object';
      var count = isRetry ? (opts.count || 0) : 0;
      var mySeq = isRetry && opts.seq ? opts.seq : (++pushSeq);
      if (!isRetry) inFlightPushes++;

      var attrs = buildAttrs();
      var formData = new FormData();
      Object.keys(attrs).forEach(function(k) {
        formData.append('attributes[' + k + ']', attrs[k]);
      });

      return fetch('/cart/update.js', {
        method: 'POST',
        body: formData,
        keepalive: true,
        credentials: 'same-origin'
      }).then(function(response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.json();
      }).then(function(cart) {
        if (mySeq >= lastAppliedSeq) lastAppliedSeq = mySeq;
        inFlightPushes = Math.max(0, inFlightPushes - 1);

        // Rehidratación defensiva: si el theme re-renderizó el cart drawer
        // mientras este push estaba en vuelo, los nuevos DOM inputs quedaron
        // vacíos y loadStateFromCart se saltó por inFlightPushes > 0. Pintamos
        // los valores desde la respuesta del server (que es lo más fresco que
        // tenemos en este momento). Solo aplica cuando el cart tiene factura.
        try {
          var els = getInputs();
          var cartAttrs = (cart && cart.attributes) || {};
          if (cartAttrs.billing_document_type === '33' && !inputsAreFocused()) {
            if (els.rut && !els.rut.value && cartAttrs.billing_rut) {
              els.rut.value = cartAttrs.billing_rut;
            }
            if (els.company && !els.company.value && cartAttrs.billing_company_name) {
              els.company.value = cartAttrs.billing_company_name;
            }
            if (els.giro && !els.giro.value && cartAttrs.billing_business_type) {
              els.giro.value = cartAttrs.billing_business_type;
            }
            showInvoiceFields();
            updateRadioVisuals();
            validateAll(false);
          }
        } catch (e) {}

        return cart;
      }).catch(function(err) {
        if (count < MAX_RETRIES - 1) {
          var delay = BASE_RETRY_DELAY * Math.pow(2, count);
          return new Promise(function(resolve, reject) {
            setTimeout(function() {
              pushCartAttributes({ count: count + 1, seq: mySeq }).then(resolve).catch(reject);
            }, delay);
          });
        }
        inFlightPushes = Math.max(0, inFlightPushes - 1);
        throw err;
      });
    }

    function saveBuffer() {
      try {
        var els = getInputs();
        var data = {
          docType: getDocType(),
          rut: els.rut ? els.rut.value : '',
          company: els.company ? els.company.value : '',
          giro: els.giro ? els.giro.value : '',
          ts: Date.now()
        };
        sessionStorage.setItem(SS_KEY, JSON.stringify(data));
      } catch(e) {}
    }

    function readBuffer() {
      try {
        var raw = sessionStorage.getItem(SS_KEY);
        if (!raw) return null;
        var data = JSON.parse(raw);
        if (!data.ts || (Date.now() - data.ts) > BUFFER_TTL_MS) {
          sessionStorage.removeItem(SS_KEY);
          return null;
        }
        return data;
      } catch(e) { return null; }
    }

    function clearBuffer() {
      try { sessionStorage.removeItem(SS_KEY); } catch(e) {}
    }

    // safePush: debounced + handler de error visible al user.
    // Si los 3 retries fallan, mostramos error en topErr y bloqueamos checkout —
    // sin esto, fail silencioso = boleta con datos rotos sin que user se entere.
    var safePush = debounce(function() {
      pushCartAttributes(0).then(function() {
        clearBuffer();
        clearTopError();
      }).catch(function(err) {
        var els = getInputs();
        if (els.topErr) {
          els.topErr.textContent = 'No pudimos guardar tus datos de facturación. Revisa tu conexión.';
          els.topErr.dataset.bfNetErr = 'true';
          els.topErr.style.display = 'block';
        }
        toggleCheckoutBtns(false);
      });
    }, 250);

    // loadStateFromCart: /cart.js es source of truth, sessionStorage cubre el gap
    // del debounce (datos tipeados pero no pusheados todavía).
    // GUARD CRÍTICO: skip si user está tipeando (focus) o si hay pushes pendientes
    // — sin esto, un cart:updated event mid-typing pisa lo que el user escribió.
    function loadStateFromCart() {
      if (inputsAreFocused() || inFlightPushes > 0) return Promise.resolve();

      return fetch('/cart.js', { credentials: 'same-origin' })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          // Re-check después del fetch: el user pudo haber empezado a tipear en estos ms.
          if (inputsAreFocused() || inFlightPushes > 0) return;

          var els = getInputs();
          var docTypeRadios = document.querySelectorAll('input[name="attributes[billing_document_type]"]');
          var attrs = cart.attributes || {};
          var buffer = readBuffer();

          var rawDoc = attrs.billing_document_type;
          var docType = '39';
          if (rawDoc === '33' || rawDoc === 'factura') docType = '33';
          else if (rawDoc === '39' || rawDoc === 'boleta') docType = '39';

          if (buffer && buffer.docType === '33' && buffer.rut && !attrs.billing_rut) {
            docType = buffer.docType;
            docTypeRadios.forEach(function(r) { r.checked = r.value === docType; });
            if (els.rut) els.rut.value = buffer.rut || '';
            if (els.company) els.company.value = buffer.company || '';
            if (els.giro) els.giro.value = buffer.giro || '';
            pushCartAttributes(0).then(clearBuffer).catch(function() {});
          } else {
            docTypeRadios.forEach(function(r) { r.checked = r.value === docType; });
            if (els.rut) els.rut.value = attrs.billing_rut || '';
            if (els.company) els.company.value = attrs.billing_company_name || '';
            if (els.giro) els.giro.value = attrs.billing_business_type || '';
          }

          showInvoiceFields();
          updateRadioVisuals();
          validateAll(false);
        })
        .catch(function() {});
    }

    // Event delegation para checkout buttons (capturing phase para ganar a otros listeners)
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('a[href$="/checkout"], button[name="checkout"], input[name="checkout"]');
      if (!btn) return;

      if (!document.querySelector('.boleta-factura-wrapper')) return;

      e.preventDefault();
      e.stopPropagation();

      if (!validateAll(true)) return;

      toggleCheckoutBtns(false);
      pushCartAttributes(0).then(function() {
        window.location.href = '/checkout';
      }).catch(function() {
        toggleCheckoutBtns(true);
        alert('Hubo un problema al guardar tus datos de facturación. Intenta de nuevo.');
      });
    }, true);

    function init() {
      var docTypeRadios = document.querySelectorAll('input[name="attributes[billing_document_type]"]');
      if (!docTypeRadios.length) return;

      loadStateFromCart();
      showInvoiceFields();
      updateRadioVisuals();
      validateAll(false);

      docTypeRadios.forEach(function(r) {
        if (r.dataset.bfBound === 'true') return;
        r.dataset.bfBound = 'true';
        r.addEventListener('change', function() {
          updateRadioVisuals();
          showInvoiceFields();
          validateAll(false);
          saveBuffer();
          safePush();
        });
      });

      // Click handler en los labels (no usamos onclick inline — duplica el handler
      // con el change listener y dispara setDocType 2x por click).
      var options = document.querySelectorAll('.bf-radio-option');
      options.forEach(function(opt) {
        if (opt.dataset.bfClickBound === 'true') return;
        opt.dataset.bfClickBound = 'true';
        opt.addEventListener('click', function() {
          var radio = opt.querySelector('input[type="radio"]');
          if (!radio || radio.checked) return;
          radio.checked = true;
          updateRadioVisuals();
          showInvoiceFields();
          validateAll(false);
          saveBuffer();
          safePush();
          fireChange(radio);
        });
      });

      var els = getInputs();
      [els.rut, els.company, els.giro].forEach(function(inp) {
        if (!inp || inp.dataset.bfBound === 'true') return;
        inp.dataset.bfBound = 'true';

        if (inp.id === 'bf-rut') {
          inp.addEventListener('input', function(e) {
            e.target.value = fmtRut(e.target.value);
            saveBuffer();
            safePush();
          });
        } else {
          inp.addEventListener('input', function() {
            validateAll(false);
            saveBuffer();
            safePush();
          });
        }

        inp.addEventListener('blur', function(e) {
          e.target.dataset.hasBlurred = 'true';
          validateAll(false);
          pushCartAttributes(0).then(clearBuffer).catch(function() {});
        });
      });
    }

    // Guard document.readyState: el script se carga desde theme.liquid con defer,
    // que ejecuta antes de DOMContentLoaded. Pero si por algún motivo llega tarde
    // (parsed después de DCL), addEventListener nunca dispara → init nunca corre.
    function bootstrap() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
          init();
          bindCartFormUpdated();
        });
      } else {
        init();
        bindCartFormUpdated();
      }
    }

    // Eventos canónicos de re-render del cart drawer por theme:
    // - shopify:section:load: Section Rendering API estándar
    // - cart:updated / cart-updated: Dawn + Krown + variantes
    // - cart:refresh: Eurus / Omni Themes
    ['shopify:section:load', 'cart:updated', 'cart:refresh', 'ajaxCart:opened', 'cart-updated', 'add-to-cart'].forEach(function(ev) {
      document.addEventListener(ev, function() {
        setTimeout(init, 50);
      });
    });

    window.addEventListener('pageshow', function(e) {
      if (e.persisted) setTimeout(init, 50);
    });

    // Algunos themes disparan 'cart-updated' en el element <cart-form> sin bubble.
    // En Eurus no aplica, pero queda como defensa multi-theme.
    function bindCartFormUpdated() {
      var cartForms = document.querySelectorAll('cart-form');
      for (var i = 0; i < cartForms.length; i++) {
        var cf = cartForms[i];
        if (cf.dataset.bfKrownBound === 'true') continue;
        cf.dataset.bfKrownBound = 'true';
        cf.addEventListener('cart-updated', function() {
          setTimeout(init, 50);
        });
      }
    }

    // MutationObserver debounced — el callback original corría cientos de veces
    // por segundo en páginas con animaciones del theme. 100ms es suficiente para
    // detectar cart drawer re-renders sin matar CPU mobile.
    var moDebounced = debounce(function() {
      var el = document.querySelector('input[name="attributes[billing_document_type]"]');
      if (el && el.dataset.bfBound !== 'true') init();
      bindCartFormUpdated();
    }, 100);
    new MutationObserver(moDebounced).observe(document.body, { childList: true, subtree: true });

    // Flush final en visibilitychange/beforeunload — solo si los datos validan.
    // Sin validateAll, podríamos enviar RUT/giro/razón social rotos a Bsale
    // si el user cierra el tab mid-typing.
    function flushKeepalive() {
      if (!isInvoice()) return;
      if (!validateAll(false)) return;
      var attrs = buildAttrs();
      var formData = new FormData();
      Object.keys(attrs).forEach(function(k) {
        formData.append('attributes[' + k + ']', attrs[k]);
      });
      fetch('/cart/update.js', {
        method: 'POST',
        body: formData,
        keepalive: true,
        credentials: 'same-origin'
      }).catch(function() {});
    }

    document.addEventListener('visibilitychange', function() {
      if (document.hidden) flushKeepalive();
    });

    window.addEventListener('beforeunload', flushKeepalive);

    bootstrap();

  })();
}
